import { SimpleGrid } from '@cardboard-ui/react';
import React, { PropsWithChildren } from 'react';

export const SpacesList: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <SimpleGrid
      columns={2}
      columnGap={4}
      rowGap={4}
      autoRows="1fr"
      minChildWidth="160px"
    >
      {children}
    </SimpleGrid>
  );
};
